import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Про нас',
    href: '#about'
  }, {
    name: 'Послуги',
    href: '#services'
  }, {
    name: 'Портфоліо',
    href: '#portfolio'
  }, {
    name: 'Відгуки',
    href: '#testimonials'
  }];
  return <>
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${isScrolled ? 'bg-background/90 backdrop-blur-md py-4 border-b border-border' : 'bg-transparent py-8'}`} data-id="element-100">
        <div className="container mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-101">
          {/* Logo */}
          <a href="#" className="text-2xl font-serif tracking-widest uppercase text-primary" data-id="element-102">
            Aura
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-12" data-id="element-103">
            <div className="flex gap-8" data-id="element-104">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-[11px] font-sans font-medium uppercase tracking-widest text-secondary hover:text-primary transition-colors duration-500 relative group" data-id="element-105">
                  {link.name}
                  <span className="absolute -bottom-2 left-0 w-0 h-[1px] bg-primary transition-all duration-500 group-hover:w-full" data-id="element-106"></span>
                </a>)}
            </div>

            <div className="flex items-center gap-6 border-l border-border pl-8" data-id="element-107">
              <div className="flex gap-3 text-[10px] font-sans font-medium uppercase tracking-widest" data-id="element-108">
                <button className="text-primary" data-id="element-109">UA</button>
                <button className="text-secondary hover:text-primary transition-colors" data-id="element-110">
                  RU
                </button>
              </div>
              <a href="#contact" className="px-6 py-3 border border-border text-primary text-[11px] font-medium uppercase tracking-widest hover:bg-primary hover:text-background transition-all duration-500" data-id="element-111">
                Зв'язатися
              </a>
            </div>
          </div>

          {/* Mobile Toggle */}
          <button className="md:hidden text-primary" onClick={() => setIsMobileMenuOpen(true)} data-id="element-112">
            <Menu size={24} strokeWidth={1} data-id="element-113" />
          </button>
        </div>
      </motion.nav>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-114">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.5
      }} className="fixed inset-0 z-[60] bg-background flex flex-col justify-center items-center" data-id="element-115">
            <button className="absolute top-8 right-6 text-primary p-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-116">
              <X size={32} strokeWidth={1} data-id="element-117" />
            </button>

            <div className="flex flex-col items-center gap-10 text-center" data-id="element-118">
              {navLinks.map((link, i) => <motion.a key={link.name} href={link.href} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1 * i + 0.2
          }} onClick={() => setIsMobileMenuOpen(false)} className="text-4xl font-serif text-secondary hover:text-primary transition-colors duration-500" data-id="element-119">
                  {link.name}
                </motion.a>)}

              <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.6
          }} className="mt-12 flex flex-col items-center gap-8" data-id="element-120">
                <div className="flex gap-6 text-sm font-sans uppercase tracking-widest" data-id="element-121">
                  <button className="text-primary" data-id="element-122">UA</button>
                  <button className="text-secondary" data-id="element-123">RU</button>
                </div>
                <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="px-10 py-4 border border-primary text-primary text-xs uppercase tracking-widest hover:bg-primary hover:text-background transition-all duration-500" data-id="element-124">
                  Зв'язатися
                </a>
              </motion.div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}